module.exports = __webpack_public_path__ + "img/google-docs.88dc1465.svg";